/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import ApiConstant from '../../constants/api.constant';
import httpService from '../http.service';
import { getServiceHostPreference } from '../utils/getServiceHostPreference';
import { processAirportMetar } from './processAirportMetar';

const getAirportMetarData = async (airportForecast) => {
  const data = await httpService.http_get(
    `${getServiceHostPreference()}${ApiConstant.newMetarAirportApi}${airportForecast.icao_id}&bncachebuster=${Date.now()}`,
  );
  return processAirportMetar(data, airportForecast);
};

export { getAirportMetarData };
